import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { UserService } from '../../services';
import { User } from 'src/app/models';

@Component({
  selector: 'user-list-item',
  templateUrl: './user-list-item.component.html',
  styleUrls: ['./user-list-item.component.scss'],
})
export class UserListItemComponent implements OnInit {

  @Input() detail: string;
  @Input() isSelected: boolean = false;
  @Input() userId: string;
  @Input() userObj: User;
  @Input() control: "default" | "select" | "remove" = "default";
  @Input() isLast: boolean = false;
  @Input() status: {
    class: string,
    text: string
  }
  @Input() showStatus = false;
  @Output() onUserClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUserSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUserRemoved: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUserLoaded: EventEmitter<any> = new EventEmitter<any>();

  public user: User;
  constructor(private userService: UserService) { }

  ngOnInit() {
    this.loadData();
  }

  async ngOnChanges(changes: SimpleChanges) {
  }

  async loadData() {
    if(this.userObj) {
      this.user = this.userObj
    } else if(this.userId) {
      this.user = await this.userService.getUserAsPromise(this.userId);
      this.onUserLoaded.emit({user: this.user});
    } else {
      this.user = new User({});
    }
  }

  userClicked() {
    this.onUserClicked.emit({user: this.user});
    this.isSelected = !this.isSelected;
    this.userSelected();
  }

  userSelected() {
    this.onUserSelect.emit({isSelected: this.isSelected, user: this.user});
  }

  userRemoved(event) {
    event.stopPropagation();
    this.onUserRemoved.emit({user: this.user});
  }

  getClientStatus(status) {
    let toReturn = "successStatus"
    switch (status) {
      case "active":
        toReturn = "successStatus"
        break;
      case "lead":
        toReturn = "neutralStatus";
        break;
      case "inactive":
        toReturn = "warningStatus";
        break;
      case "disabled":
        toReturn = "errorStatus";
        break;
      default:
        break;
    }
    return toReturn
  }
}
